export const AuthenticationPath = '/api/authentication'

export type LogonRequestData = {
  accountIdentifier: string
  password: string
  rememberAccount: boolean
  keepLoggedIn: boolean
  deviceSecret: string
  deviceGroupKey?: string
  deviceKey?: string
  loginViaBioAuth?: boolean
}

type SuccessfulLoginResult = {
  status: 'SUCCESSFUL'
  accountNumber: number
  newDeviceGroupKey?: string
  newDeviceKey?: string
}
type FailedLoginResult = {
  status: 'FAILED'
  error?: string
}
type ChangePasswordResult = {
  status: 'PASSWORD_CHANGE_REQUIRED'
  error?: string
  accountNumber: number
}
type MFAChallengeResult = {
  status: 'MFA_REQUIRED'
  accountNumber: number
  mfaSessionId: string
  mfaFactor: 'SMS' | 'EMAIL'
  mfaHint: string
}

export type LogonResult =
  | SuccessfulLoginResult
  | FailedLoginResult
  | ChangePasswordResult
  | MFAChallengeResult

export type AttemptLoginReturn = LogonResult & {
  errorMessage?: string
}

export type LogonWithMfaRequest = {
  accountNumber: number
  mfaSessionId: string
  mfaFactor: string
  mfaCode: string
  rememberAccount: boolean
  keepLoggedIn: boolean
}

export type LogonWithMfaResult = {
  isSuccessful: boolean
  newDeviceGroupKey?: string
  newDeviceKey?: string
  errorMessage?: string
}

export type RegisterTrustedDeviceRequest = {
  deviceSecret: string
  deviceKey: string
  deviceGroupKey: string
}

export type ForgetTrustedDeviceRequest = {
  deviceKey: string
}

/**
 * HTMLString is just an alias to string to inform
 * the developer that the string contains HTML.
 */
type HTMLString = string

type IsLoggedIn = {
  accountNumber: number
  loggedIn: true
}

type IsLoggedOut = {
  accountNumber: null
  loggedIn: false
}

export type IsAuthenticated = (IsLoggedIn | IsLoggedOut) & {
  token: HTMLString
}
